/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';

/** Common Components */
import CardSection from '../../components/ui/card/CardSection';
import FinalMolGrid from '../../components/FinalMolGrid/FinalMolGrid';
import FormCreator from '../../components/finalForms/FormCreator';
import { encryptUrlData } from '../../services/CryptoService';
import SwalAlert from '../../services/swalService/SwalService';
import Buttons from '../../components/ui/button/Buttons';
import CenterModel from '../../components/ui/centerModel/CenterModel';

/** Configuration Files */
import { GroupManagementGridConfig } from "./config/GroupManagement.data"
import { groupData } from './config/Group.data';
/** RTK Query */
import { useAddEditGroupMutation, useDeleteGroupMutation, useGroupManagementListMutation } from '../../app/services/groupManagementAPI';
import useDebounce from '../../app/customHooks/useDebounce';
import ToastService from '../../services/toastService/ToastService';

const GroupManagement = () => {
  const molGridRef = useRef();
  const groupRef = useRef();
  const navigate = useNavigate();
  const { confirm } = SwalAlert();

  /* State */
  const [groupForm] = useState(groupData);
  const [searchText, setSearchText] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const debouncedSearch = useDebounce(searchText, 300);
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  // API's Calls
  const [getGroupList,
    { isLoading: isGroupListLoading,
      isSuccess: isGroupListSuccess,
      data: groupListData
    }] = useGroupManagementListMutation();

  const [deleteGroup, {
    isSuccess: isGroupDeleted,
    data: deleteGroupData
  }] = useDeleteGroupMutation();

  const [addEditGroup, {
    isSuccess: isSucessAddEditGroup,
    data: addEditGroupData
  }] = useAddEditGroupMutation();

  const createGroupListRequest = (pageObject) => ({
    pagination: {
      pageNumber: pageObject.pageNumber,
      pageSize: pageObject.pageSize,
    },
    filters: { searchText: debouncedSearch },
  });

  //** useEffect's */

  useEffect(() => {
    if (molGridRef.current) {
      const pageObject = molGridRef.current.getDefulatPageObject();
      setCurrentPage(pageObject.pageNumber);
      setPageSize(pageObject.pageSize);
      getGroupmoduleList(pageObject);
    }
  }, [debouncedSearch]);


  useEffect(() => {
    if (isGroupListSuccess && groupListData) {
      if (groupListData.dataSource) {
        setDataSource(groupListData.dataSource);
      }
      if (groupListData.totalRecord) {
        setTotalRowCount(groupListData.totalRecord);
      }
    }
  }, [isGroupListSuccess, groupListData]);

  useEffect(() => {
    if (isGroupDeleted && deleteGroupData && molGridRef.current) {
      ToastService.success(deleteGroupData.errorMessage);
      const pageObject = molGridRef.current.getCurrentPageObject();
      getGroupmoduleList(pageObject);
    }
  }, [isGroupDeleted, deleteGroupData]);

  useEffect(() => {
    if (isSucessAddEditGroup && addEditGroupData) {
      if (addEditGroupData.errorMessage.includes("exists")) {
        ToastService.error(addEditGroupData.errorMessage);
        return;
      }
      ToastService.success(addEditGroupData.errorMessage);
      if (molGridRef.current) {
        const pageObject = molGridRef.current.getCurrentPageObject();
        getGroupmoduleList(pageObject);
      }
      backToList();
    }
  }, [isSucessAddEditGroup, addEditGroupData]);

  //** Funcation's */

  const getGroupmoduleList = (pageObject) => {
    setCurrentPage(pageObject.pageNumber);
    setPageSize(pageObject.pageSize);
    const request = createGroupListRequest(pageObject);
    getGroupList(request);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page.pageNumber);
    setPageSize(page.pageSize);
    const request = createGroupListRequest(page);
    getGroupList(request);
  };

  const onEditAction = (data) => {
    navigate(`/admin/GroupDetails/${encryptUrlData(data.groupId)}`);
  };

  const onDeleteClick = (data) => {
    confirm("Delete?", "Are you sure you want to Delete?", "Delete", "Cancel")
      .then((confirmed) => {
        if (confirmed) {
          deleteGroup(data.groupId);
        }
      });
  };

  const AddhandleToggleModal = () => {
    setShowModal(!showModal);
    if (molGridRef.current) {
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      const request = createGroupListRequest(currentPageObject);
      getGroupList(request);
    }
  };

  const handleSubmit = () => {
    const groupData = groupRef.current.getFormData();
    if (groupData) {
      const requestUpdateData = {
        groupId: groupData?.groupId,
        groupName: groupData?.groupName,
      };
      addEditGroup(requestUpdateData);
    }
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const backToList = () => setShowModal(false);

  const actionHandler = {
    EDIT: onEditAction,
    DELETE: onDeleteClick,
  };

  return (
    <div className='center-top-space'>
      <CardSection
        isContentLoading={isGroupListLoading}
        cardTitle={"Group Member List"}
        rightButton={true}
        buttonClassName="theme-btn"
        titleButtonClick={AddhandleToggleModal}
        buttonText="Add Group"
        textWithIcon={true}
        iconName="material-symbols:add-rounded"
        fontIcon={true}
        handleChange={handleSearchChange}
        searchInputName="Search via Group Name"
        searchInput={true}
        cardInfo={false}
      >
        <div>
          <FinalMolGrid
            ref={molGridRef}
            configuration={GroupManagementGridConfig}
            dataSource={dataSource}
            allowPagination={true}
            pagination={{
              totalCount: totalRowCount,
              pageSize: pageSize,
              currentPage: currentPage,
            }}
            onPageChange={handlePageChange}
            onActionChange={actionHandler}
            isLoading={isGroupListLoading}
          />
        </div>

        <div>
          {showModal && (
            <CenterModel
              showModal={showModal}
              handleToggleModal={AddhandleToggleModal}
              modalTitle="Add Group"
              modelSizeClass="w-40"
            >
              <form>
                <div className="row mt-0 edit-project-form">
                  <FormCreator
                    config={groupForm}
                    ref={groupRef}
                    {...groupForm}
                  />
                </div>
              </form>
              <div className="d-flex justify-content-end">
                <Buttons
                  buttonTypeClassName="dark-btn"
                  buttonText="Cancel"
                  onClick={backToList}
                />
                <Buttons
                  buttonTypeClassName="theme-btn ml-4"
                  buttonText={"Add"}
                  onClick={handleSubmit}
                />
              </div>
            </CenterModel>
          )}
        </div>
      </CardSection>
    </div>
  );
};

export default GroupManagement;
